'use strict';
/**
 * Internationalization helper methods for formatting distances, prices, and other locale-specific content.
 *
 * This module provides utility functions for:
 * - Distance formatting (metric/imperial units)
 * - Price formatting with currency symbols
 */
void function (i18n) {
    window.i18n = i18n;
    const priceFormatters = new Map();
    /**
     * Formats a distance value according to the user's locale preferences.
     *
     * @param value - The distance value in kilometers
     * @param shortAsMetres - If true and value is less than 1km, displays in metres instead
     * @returns Formatted distance string with appropriate unit (km, m, or miles)
     */
    i18n.formatDistance = function (value, shortAsMetres = false) {
        let unit;
        let result;
        if (i18n.usesMetric) {
            if (value < 1 && shortAsMetres) {
                value *= 1000;
                unit = 'm';
            }
            else
                unit = 'km';
            result = value.toString();
        }
        else {
            result = (value * 0.6213).toFixed(1);
            unit = 'miles'; // value is a string with decimal precision, so 1 mile is returned as 1.0 and plural applies.
        }
        return `${result}${unit}`;
    };
    /**
     * Formats a price value according to the user's locale and currency preferences.
     *
     * @param value - The price value to format
     * @param currency - The currency code (e.g., 'USD', 'EUR')
     * @param maxDigits - Maximum number of decimal places to display (default: 2)
     * @param canShrink - If true, removes decimal places for whole numbers (default: false)
     * @returns Formatted price string with currency symbol
     */
    i18n.formatPrice = function (value, currency, maxDigits = 2, canShrink = false) {
        if (canShrink && Number.isInteger(value))
            maxDigits = 0;
        const lang = document.documentElement.getAttribute('lang') || undefined;
        const key = currency + lang + maxDigits;
        let formatter = priceFormatters.get(key);
        // create formatter if it doesn't exist
        if (!formatter) {
            const opts = {
                style: 'currency',
                currency: currency,
                currencyDisplay: 'symbol',
                maximumFractionDigits: maxDigits,
            };
            formatter = new Intl.NumberFormat(lang, opts);
            priceFormatters.set(key, formatter);
        }
        return formatter.format(value);
    };
}(window.i18n || {});
